const clamp = (min, max, next) => {
	if (next < min) {
		return min;
	} else if (next > max) {
		return max;
	} else {
		return next;
	}
}

export default clamp;


// WEBPACK FOOTER //
// ./scripts/util/clamp.js